//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "CooperativeDisperse",
  data() {
    return {};
  },
  components: {},
  mounted() {},
};
